import * as types from "./types";

export const getListMenu = (payload) => ({
  type: types["GET_LIST_MENU"],
  payload,
});

export const setListMenu = (payload) => ({
  type: types["SET_LIST_MENU"],
  payload,
});

export const getListStaff = (payload) => ({
  type: types["GET_LIST_STAFF"],
  payload,
});

export const setListStaff = (payload) => ({
  type: types["SET_LIST_STAFF"],
  payload,
});

export const getListTable = (payload) => ({
  type: types["GET_LIST_TABLE"],
  payload,
});

export const setListTable = (payload) => ({
  type: types["SET_LIST_TABLE"],
  payload,
});

export const getListCustomer = (payload) => ({
  type: types["GET_LIST_CUSTOMER"],
  payload,
});

export const setListCustomer = (payload) => ({
  type: types["SET_LIST_CUSTOMER"],
  payload,
});

export const getListParticipants = (payload) => ({
  type: types["GET_LIST_PARTICIPANTS"],
  payload,
});

export const setListParticipants = (payload) => ({
  type: types["SET_LIST_PARTICIPANTS"],
  payload,
});

export const getListSeat = (payload) => ({
  type: types["GET_LIST_SEAT"],
  payload,
});

export const setListSeat = (payload) => ({
  type: types["SET_LIST_SEAT"],
  payload,
});
